import { CalculatedColumn } from "../types";

export function groupRows<R extends object>(rows: R[], groupColumns: CalculatedColumn<R>[]): R[][] {
  return rows.reduce<R[][]>((groups, row) => {
    const group = groups.find(([groupRow]) => groupColumns.every(col => col.valueGetter(row) === col.valueGetter(groupRow)));

    if (group) {
      group.push(row);
    } else {
      groups.push([row]);
    }

    return groups;
  }, []);
}
